/**
 * Keeps the scroll smooth — pairs with scroll-smooth.css.
 *
 * It adds no animation. It only marks two states that the stylesheet (and the hero
 * canvas) use to stop doing expensive work at the moment it would be felt:
 *
 *   html.is-scrolling   the view is moving right now
 *   .scroll-idle        this section is off screen
 *
 * While the page moves, the blurred cards go flat and the repainting animations
 * pause; both come back the instant scrolling stops. Off screen, animations idle
 * entirely, so nothing is repainting behind your back further down the page.
 *
 * This theme scrolls inside `.page-wrapper` rather than the window, so that is where
 * the listener goes, with the window kept as a fallback.
 */
const IDLE_DELAY = 140;

function trackScrolling() {
  const root = document.documentElement;
  const scroller = document.querySelector('.page-wrapper') || window;
  let idleTimer = 0;
  let scrolling = false;

  const onScroll = () => {
    if (!scrolling) {
      scrolling = true;
      root.classList.add('is-scrolling');
    }
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      scrolling = false;
      root.classList.remove('is-scrolling');
    }, IDLE_DELAY);
  };

  scroller.addEventListener('scroll', onScroll, { passive: true });
  if (scroller !== window) window.addEventListener('scroll', onScroll, { passive: true });
}

function idleOffscreenSections() {
  const targets = document.querySelectorAll('[data-scroll-idle]');
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) entry.target.classList.toggle('scroll-idle', !entry.isIntersecting);
    },
    // A margin either side, so a section is awake slightly before it is reached.
    { rootMargin: '15% 0px' }
  );
  for (const target of targets) observer.observe(target);
}

function init() {
  trackScrolling();
  idleOffscreenSections();
  document.addEventListener('shopify:section:load', idleOffscreenSections);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
else init();
